import { router } from 'expo-router';
import Animated, { FadeIn } from 'react-native-reanimated';
import {
    Button,
    ButtonSize,
    ButtonVariant,
    FootnoteRegular,
    H2Emphasized,
    Image,
    SafeAreaView,
    Shadows,
    Text,
    View,
    YStack,
} from 'smoothie';

import { useMembershipGuidanceSessionInfo } from '../hooks/useMembershipGuidanceSessionInfo';
import type { GuidanceSessionType } from '../types/GuidanceSessions';

interface BookSessionCardProps {
    sessionType: GuidanceSessionType | null;
    hideButton?: boolean;
}

const BookSessionCard = ({ sessionType, hideButton }: BookSessionCardProps) => {
    const { getSessionDetails } = useMembershipGuidanceSessionInfo();

    if (sessionType == null) {
        return (
            <SafeAreaView style={{ flex: 1 }}>
                <View margin={20}>
                    <Text>Invalid session type</Text>
                </View>
            </SafeAreaView>
        );
    }

    const sessionDetails = getSessionDetails(sessionType);
    const { title, description, image } = sessionDetails;

    return (
        <Animated.View entering={FadeIn.duration(500)}>
            <YStack
                padding={20}
                paddingBottom={hideButton ? 32 : 20}
                backgroundColor="$peach300"
                borderRadius={20}
                gap={28}
                {...Shadows.SMALL}
                $sm={{ flexShrink: 1, height: 400 }}
            >
                <YStack>
                    <H2Emphasized marginVertical={6}>{title}</H2Emphasized>
                    <FootnoteRegular maxWidth={270} color="$gray1100">
                        {description}
                    </FootnoteRegular>
                </YStack>

                <View alignSelf="center" flex={1}>
                    <Image
                        source={image}
                        resizeMode="contain"
                        height={hideButton ? 186 : 166}
                    />
                </View>
                {!hideButton && (
                    <Button
                        variant={ButtonVariant.PRIMARY}
                        size={ButtonSize.LARGE}
                        text="Book your next session"
                        onPress={() => {
                            router.navigate({
                                pathname:
                                    '/guidance-sessions/book-session-details',
                                params: {
                                    sessionType,
                                },
                            });
                        }}
                    />
                )}
            </YStack>
        </Animated.View>
    );
};

export default BookSessionCard;
